import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormBuilder } from '@angular/forms';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
  public UPLOADPATH = 'useruploads/';

  contactForm: UntypedFormGroup;
  fontcolor: any;
  user: any;
  plans$: Observable<any>;
  uid: string;

  tokenUsageHistory: any[] = [];
  tokenUsageHistoryLoading: boolean = false;
  totalTokensUsed: number = 0;

  // Add user account token tracking
  userTokensUsed: number = 0;
  userTotalRequests: number = 0;
  userLastTokenUsage: any = null;

  // Add separate tracking for input and output tokens
  userInputTokensUsed: number = 0;
  userOutputTokensUsed: number = 0;
  totalInputTokensUsed: number = 0;
  totalOutputTokensUsed: number = 0;

  // Add cost tracking
  userTotalCost: number = 0;
  userInputCost: number = 0;
  userOutputCost: number = 0;
  userLastCostUpdate: any = null;

  constructor(private http: HttpClient, private authService: AuthService,
    public afs: AngularFirestore,
    @Inject(FormBuilder) private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute, private snackBar: MatSnackBar,
    private cdRef: ChangeDetectorRef) {
    this.contactForm = fb.group({
      firstName: '',
      lastName: '',
      street: null,
      streetno: null,
      zip: null,
      city: '',
      country: '',
      password: '',
      taxrate: null,
      storename: '',
      storeurl: '',
      redirecturl: '',
      shippingrate: null,
      cssrules: '',
      color: '',
      fontsize: null,
      email: '',
      fontcolor: '#000000',
      backgroundcolor: '#e8e8e8',
      chargeshipping: '1',
      sepanetsandbox: '1',
      paypalname: '',
      paypalkey: '',
      braintreemerchantid: '',
      braintreeprivatekey: '',
      braintreepublickey: '',
      sepanetname: '',
      sepanetkey: '',
      logourl: '',
      gcode: '',
      stoken: ''
    });
    console.log('this.contactForm', this.contactForm);
    this.authService.authState.subscribe(user => {
      this.user = user;
      this.uid = user?.uid;
      if (this.uid) {
        // Load user settings
        this.afs.collection('users').doc(this.uid).snapshotChanges().subscribe(x => {
          let data = x.payload.data();
          if (!data) {
            data = { settings: {} };
          }
          console.log('User data loaded:', data);
          this.contactForm.patchValue((data as any).settings);

          console.log('contactform', this.contactForm);
          const userDoc = data as any;
          if (!userDoc.plan) {
            userDoc.plan = "free";
          }

          // Load user account token information
          this.userTokensUsed = userDoc.tokensUsed || 0;
          this.userTotalRequests = userDoc.totalRequests || 0;
          this.userLastTokenUsage = userDoc.lastTokenUsage;

          // Load separate input and output token counts from user account
          this.userInputTokensUsed = userDoc.inputTokensUsed || 0;
          this.userOutputTokensUsed = userDoc.outputTokensUsed || 0;

          // Load cost information from user account
          this.userTotalCost = userDoc.totalCost || 0;
          this.userInputCost = userDoc.inputCost || 0;
          this.userOutputCost = userDoc.outputCost || 0;
          this.userLastCostUpdate = userDoc.lastCostUpdate;

          console.log('User token data loaded:', {
            tokensUsed: this.userTokensUsed,
            totalRequests: this.userTotalRequests,
            lastTokenUsage: this.userLastTokenUsage,
            inputTokensUsed: this.userInputTokensUsed,
            outputTokensUsed: this.userOutputTokensUsed,
            totalCost: this.userTotalCost,
            inputCost: this.userInputCost,
            outputCost: this.userOutputCost,
            lastCostUpdate: this.userLastCostUpdate,
            fullUserDoc: userDoc
          });

          // DEBUGGING: Check for potential userID mismatches
          console.log('DEBUGGING UID COMPARISON:');
          console.log('Settings component uid:', this.uid);
          console.log('Auth user uid:', user?.uid);

          // Try to get customerid from localStorage or other sources that editor might use
          try {
            const storedProject = localStorage.getItem('PROJECT');
            console.log('Stored PROJECT (might contain customerid):', storedProject);

            // Also check if there are any other stored user identifiers
            const allLocalStorageKeys = Object.keys(localStorage);
            const userRelatedKeys = allLocalStorageKeys.filter(key =>
              key.toLowerCase().includes('user') ||
              key.toLowerCase().includes('customer') ||
              key.toLowerCase().includes('uid')
            );
            console.log('User-related localStorage keys:', userRelatedKeys);
            userRelatedKeys.forEach(key => {
              console.log(`${key}:`, localStorage.getItem(key));
            });
          } catch (e) {
            console.log('Error checking localStorage:', e);
          }

          // Force change detection to update the UI
          if (this.cdRef) {
            this.cdRef.detectChanges();
          }
        });

        // Load token usage history after uid is set
        this.loadTokenUsageHistory();
      } else {
        console.error("SettingsComponent: User not logged in.");
        // Clear token history when user logs out
        this.tokenUsageHistory = [];
        this.totalTokensUsed = 0;
        // Clear account token information
        this.userTokensUsed = 0;
        this.userTotalRequests = 0;
        this.userLastTokenUsage = null;
        this.userInputTokensUsed = 0;
        this.userOutputTokensUsed = 0;
        // Clear cost information
        this.userTotalCost = 0;
        this.userInputCost = 0;
        this.userOutputCost = 0;
        this.userLastCostUpdate = null;
      }
    });
  }

  ngOnInit() {
    // Token usage history will be loaded after user authentication in constructor
  }

  loadTokenUsageHistory(): void {
    if (!this.uid) {
      console.warn('No user ID available for loading token history');
      return;
    }

    console.log('Loading token usage history for user:', this.uid);
    console.log('User auth state:', this.user);
    this.tokenUsageHistoryLoading = true;

    // First, let's try a simpler query without orderBy to see if data exists
    console.log('DEBUGGING: Trying simple query first (no orderBy)...');
    this.afs.collection('tokenUsageHistory', ref =>
      ref.where('userId', '==', this.uid)
        .limit(50)
    ).get().subscribe(
      querySnapshot => {
        console.log('Simple query result:', querySnapshot.size, 'documents found');
        querySnapshot.forEach(doc => {
          console.log('Document found:', doc.id, doc.data());
        });

        // Now try the full query with orderBy
        this.afs.collection('tokenUsageHistory', ref =>
          ref.where('userId', '==', this.uid)
            .orderBy('timestamp', 'desc')
            .limit(50)
        ).snapshotChanges().pipe(
          map(actions => actions.map(a => {
            const data = a.payload.doc.data() as any;
            data.id = a.payload.doc.id;
            return data;
          }))
        ).subscribe(
          history => {
            console.log('Raw token usage history from Firestore:', history);
            this.tokenUsageHistory = history;
            this.totalTokensUsed = history.reduce((total, record) => {
              const tokens = record.tokenUsage?.totalTokens || 0;
              console.log(`Adding ${tokens} tokens from record:`, record);
              return total + tokens;
            }, 0);
            this.tokenUsageHistoryLoading = false;
            console.log('Token usage history processed:', {
              recordCount: this.tokenUsageHistory.length,
              totalTokens: this.totalTokensUsed,
              records: this.tokenUsageHistory
            });
          },
          error => {
            console.error('Error loading token usage history with orderBy:', error);
            console.error('This might be a missing index error. Error details:', {
              code: error.code,
              message: error.message,
              uid: this.uid
            });

            // Try fallback query without orderBy
            console.log('Falling back to query without orderBy...');
            this.afs.collection('tokenUsageHistory', ref =>
              ref.where('userId', '==', this.uid)
                .limit(50)
            ).snapshotChanges().pipe(
              map(actions => actions.map(a => {
                const data = a.payload.doc.data() as any;
                data.id = a.payload.doc.id;
                return data;
              }))
            ).subscribe(
              fallbackHistory => {
                console.log('Fallback query succeeded with', fallbackHistory.length, 'records');
                this.tokenUsageHistory = fallbackHistory.sort((a, b) => {
                  const aTime = a.timestamp?.toDate?.() || new Date(a.timestamp || 0);
                  const bTime = b.timestamp?.toDate?.() || new Date(b.timestamp || 0);
                  return bTime.getTime() - aTime.getTime();
                });
                this.totalTokensUsed = this.tokenUsageHistory.reduce((total, record) => {
                  return total + (record.tokenUsage?.totalTokens || 0);
                }, 0);
                this.tokenUsageHistoryLoading = false;
              },
              fallbackError => {
                console.error('Even fallback query failed:', fallbackError);
                this.tokenUsageHistoryLoading = false;
              }
            );
          }
        );
      },
      simpleError => {
        console.error('Simple query failed:', simpleError);
        this.tokenUsageHistoryLoading = false;
      }
    );
  }

  formatDate(timestamp: any): string {
    if (!timestamp) return 'Unknown';

    // Handle Firestore timestamp
    if (timestamp.toDate) {
      return timestamp.toDate().toLocaleString();
    }

    // Handle regular Date or ISO string
    return new Date(timestamp).toLocaleString();
  }

  getRequestTypeDisplayName(requestType: string): string {
    switch (requestType) {
      case 'createGeminiPrompt': return 'AI Content Generation';
      case 'checkFormulaWithGemini': return 'Formula Check';
      case 'checkImageContentGemini': return 'Image Analysis';
      default: return requestType;
    }
  }

  getRequestTypeColor(requestType: string): string {
    switch (requestType) {
      case 'createGeminiPrompt': return '#4CAF50';
      case 'checkFormulaWithGemini': return '#2196F3';
      case 'checkImageContentGemini': return '#FF9800';
      default: return '#9E9E9E';
    }
  }

  getTokenUsageByType(): { [key: string]: number } {
    const usage = {
      createGeminiPrompt: 0,
      checkFormulaWithGemini: 0,
      checkImageContentGemini: 0
    };

    this.tokenUsageHistory.forEach(record => {
      if (usage.hasOwnProperty(record.requestType)) {
        usage[record.requestType] += record.tokenUsage?.totalTokens || 0;
      }
    });

    return usage;
  }

  // Calculate total input tokens from history
  getTotalInputTokens(): number {
    return this.tokenUsageHistory.reduce((total, record) => {
      return total + (record.tokenUsage?.promptTokens || 0);
    }, 0);
  }

  // Calculate total output tokens from history
  getTotalOutputTokens(): number {
    return this.tokenUsageHistory.reduce((total, record) => {
      return total + (record.tokenUsage?.responseTokens || 0);
    }, 0);
  }

  refreshTokenHistory(): void {
    this.loadTokenUsageHistory();
    // Also refresh user account token information
    if (this.uid) {
      this.afs.collection('users').doc(this.uid).get().subscribe(doc => {
        if (doc.exists) {
          const userData = doc.data() as any;
          this.userTokensUsed = userData.tokensUsed || 0;
          this.userTotalRequests = userData.totalRequests || 0;
          this.userLastTokenUsage = userData.lastTokenUsage;
          this.userInputTokensUsed = userData.inputTokensUsed || 0;
          this.userOutputTokensUsed = userData.outputTokensUsed || 0;
          // Refresh cost information
          this.userTotalCost = userData.totalCost || 0;
          this.userInputCost = userData.inputCost || 0;
          this.userOutputCost = userData.outputCost || 0;
          this.userLastCostUpdate = userData.lastCostUpdate;
          console.log('Refreshed user token and cost data:', {
            tokensUsed: this.userTokensUsed,
            totalRequests: this.userTotalRequests,
            lastTokenUsage: this.userLastTokenUsage,
            inputTokensUsed: this.userInputTokensUsed,
            outputTokensUsed: this.userOutputTokensUsed,
            totalCost: this.userTotalCost,
            inputCost: this.userInputCost,
            outputCost: this.userOutputCost,
            lastCostUpdate: this.userLastCostUpdate
          });
        }
      });
    }
  }

  async testTokenCreation(): Promise<void> {
    if (!this.uid) {
      console.error('No user ID available for test token creation');
      return;
    }

    console.log('Creating test token usage record...');
    console.log('Using user ID for test:', this.uid);
    console.log('User object:', this.user);

    try {
      // First, let's check if ANY documents exist in the tokenUsageHistory collection
      console.log('DEBUGGING: Checking all documents in tokenUsageHistory collection...');
      const allDocs = await this.afs.collection('tokenUsageHistory').get().toPromise();
      console.log('Total documents in tokenUsageHistory collection:', allDocs.size);

      if (allDocs.size > 0) {
        console.log('First few documents in collection:');
        allDocs.docs.slice(0, 5).forEach((doc, index) => {
          console.log(`Document ${index + 1}:`, doc.id, doc.data());
        });

        // Check if any documents match our userId
        const matchingDocs = allDocs.docs.filter(doc => {
          const data = doc.data() as any;
          return data.userId === this.uid;
        });
        console.log(`Documents matching our userId (${this.uid}):`, matchingDocs.length);
        matchingDocs.forEach((doc, index) => {
          console.log(`Matching document ${index + 1}:`, doc.id, doc.data());
        });
      } else {
        console.log('Collection is completely empty - no documents exist');
      }

      // Create a test token usage record directly in Firestore
      const testRecord = {
        userId: this.uid,
        timestamp: new Date(),
        requestId: `test-${Date.now()}`,
        requestType: 'test_request',
        tokenUsage: {
          promptTokens: 10,
          responseTokens: 5,
          totalTokens: 15
        },
        metadata: {
          date: new Date().toISOString(),
          model: 'gemini-2.5-flash'
        },
        costInfo: {
          inputCost: 0.000001,
          outputCost: 0.000002,
          totalCost: 0.000003,
          currency: 'USD',
          inputPricePerMillion: 0.075,
          outputPricePerMillion: 0.30
        }
      };

      console.log('Adding test record to tokenUsageHistory collection:', testRecord);

      const docRef = await this.afs.collection('tokenUsageHistory').add(testRecord);
      console.log('Test record created with ID:', docRef.id);

      // Verify the document was created
      const createdDoc = await docRef.get();
      console.log('Verified created document:', createdDoc.exists, createdDoc.data());

      // Refresh the history to see if it appears
      setTimeout(() => {
        this.loadTokenUsageHistory();
      }, 1000);

    } catch (error) {
      console.error('Error creating test token record:', error);
    }
  }

  testpaypal() { }

  testsepanet() { }

  public save() {
    console.log('save ', this.user, this.contactForm.value);
    if (!this.uid) {
      this.snackBar.open('Cannot save settings: User not logged in.', '', { duration: 3000 });
      return;
    }

    this.afs.doc('/users/' + this.uid).set({ settings: this.contactForm.value }, { merge: true });

    this.snackBar.open('saved', '', { duration: 3000 });
  }

  updatepayment(x) {
    if (!this.uid) {
      console.error("Cannot update payment: User not logged in.");
      return;
    }
    console.log('updatepayment ', x);
    this.afs.doc('/users/' + this.uid).set(JSON.parse(JSON.stringify({ plan: x })));
  }

  public backgroundUploaded(event) {
    console.log('background uploaded  ', event);
    this.contactForm.controls.logourl.setValue(event.url);
  }
  public uploadFailed(event) {
    window.alert('Upload fehlgeschlagen. Versuchen Sie es bitte erneut und prüfen Sie Ihre Internetverbindung.');
  }

  // Calculate total input tokens from recent history
  getTotalInputTokensFromHistory(): number {
    return this.tokenUsageHistory.reduce((total, record) => {
      return total + (record.tokenUsage?.promptTokens || 0);
    }, 0);
  }

  // Calculate total output tokens from recent history
  getTotalOutputTokensFromHistory(): number {
    return this.tokenUsageHistory.reduce((total, record) => {
      return total + (record.tokenUsage?.responseTokens || 0);
    }, 0);
  }

  // Calculate total cost from recent history
  getTotalCostFromHistory(): number {
    return this.tokenUsageHistory.reduce((total, record) => {
      return total + (record.costInfo?.totalCost || 0);
    }, 0);
  }

  // Calculate total input cost from recent history
  getTotalInputCostFromHistory(): number {
    return this.tokenUsageHistory.reduce((total, record) => {
      return total + (record.costInfo?.inputCost || 0);
    }, 0);
  }

  // Calculate total output cost from recent history
  getTotalOutputCostFromHistory(): number {
    return this.tokenUsageHistory.reduce((total, record) => {
      return total + (record.costInfo?.outputCost || 0);
    }, 0);
  }

  // Get cost usage by service type
  getCostUsageByType(): { [key: string]: number } {
    const usage = {
      createGeminiPrompt: 0,
      checkFormulaWithGemini: 0,
      checkImageContentGemini: 0
    };

    this.tokenUsageHistory.forEach(record => {
      if (usage.hasOwnProperty(record.requestType)) {
        usage[record.requestType] += record.costInfo?.totalCost || 0;
      }
    });

    return usage;
  }

  // Get model name from record
  getModelName(record: any): string {
    return record.metadata?.model || record.costInfo?.model || 'Unknown';
  }

  // Format cost for display
  formatCost(cost: number): string {
    if (cost === 0) return '$0.00';
    if (cost < 0.000001) return `$${cost.toFixed(8)}`;
    if (cost < 0.001) return `$${cost.toFixed(6)}`;
    if (cost < 1) return `$${cost.toFixed(4)}`;
    return `$${cost.toFixed(2)}`;
  }

  // Get model display name with color
  getModelDisplayInfo(modelName: string): { name: string, color: string } {
    switch (modelName) {
      case 'gemini-2.5-flash':
        return { name: 'Gemini 2.5 Flash', color: '#4CAF50' };
      case 'gemini-2.5-pro':
        return { name: 'Gemini 2.5 Pro', color: '#FF5722' };
      case 'gemini-1.5-flash-latest':
        return { name: 'Gemini 1.5 Flash', color: '#2196F3' };
      case 'gemini-1.5-pro-latest':
        return { name: 'Gemini 1.5 Pro', color: '#9C27B0' };
      default:
        return { name: modelName || 'Unknown', color: '#9E9E9E' };
    }
  }
}
